exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".vp-bm-logo-container{margin:0 auto}", ""]);

// exports
